import { MapContainer, Marker, Popup, TileLayer, Circle } from 'react-leaflet';
import { useGeolocated } from 'react-geolocated';
import { Image, List, Spin } from 'antd';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import { useEffect, useState } from 'react';
import getNearLocation from '~/hooks/useGeoLocation';
import getAllStoreData from '~/hooks/getAllStoreData';
import { IconSvg } from '~/components/constant';
import { Link } from 'react-router-dom';

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
    iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
    iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});

function Map() {
    const { coords, isGeolocationAvailable, isGeolocationEnabled } = useGeolocated({
        positionOptions: {
            enableHighAccuracy: true,
        },
        userDecisionTimeout: Infinity,
    });

    const radius = 1000;
    const [stores, setStores] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [storeData, setStoreData] = useState(null);
    const [cache, setCache] = useState({});

    useEffect(() => {
        if (coords && coords.latitude && coords.longitude) {
            getNearLocation(coords.latitude, coords.longitude, radius).then((res) => {
                setStores(res);
                setIsLoading(false);
            });
        }
    }, [coords]);

    const handlePopupClick = async (storeId) => {
        if (cache[storeId]) {
            setStoreData(cache[storeId]);
            return;
        }
        const data = await getAllStoreData(storeId);
        setCache({ ...cache, [storeId]: data });
        setStoreData(data);
    };
    return (
        <div className="w-full h-screen ">
            {!isGeolocationAvailable ? (
                <div>Trình duyệt của bạn không hỗ trợ!</div>
            ) : !isGeolocationEnabled ? (
                <div className="w-full min-h-screen text-red-500">
                    Bạn chưa cấp quyền truy cập vị trí hoặc trình duyệt của bạn không hỗ trợ!
                </div>
            ) : coords ? (
                isLoading ? (
                    <div className="w-full h-full min-h-screen flex items-center justify-center flex-col gap-2">
                        <Spin />
                        <p>Đang lấy dữ liệu...</p>
                    </div>
                ) : (
                    <div>
                        <MapContainer
                            center={[coords.latitude, coords.longitude]}
                            zoom={16}
                            style={{ height: '100vh', width: '100%', borderRadius: '10px' }}
                            scrollWheelZoom={false}
                            doubleClickZoom={false}
                        >
                            <TileLayer
                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                            />
                            <Marker position={[coords.latitude, coords.longitude]}>
                                <Popup>Bạn đang ở đây!</Popup>
                            </Marker>
                            {stores.map((store) => (
                                <Marker
                                    key={store.id}
                                    position={[store.geometry.latitude, store.geometry.longitude]}
                                    eventHandlers={{
                                        click: () => {
                                            handlePopupClick(store.parent);
                                        },
                                    }}
                                >
                                    <Popup>
                                        <div>
                                            {storeData && (
                                                <div className="flex flex-col gap-2">
                                                    <div className="flex items-center justify-center gap-2">
                                                        <img
                                                            src={IconSvg.store}
                                                            alt="store name"
                                                            className="h-3 w-3"
                                                        />
                                                        <Link
                                                            to={`/store/${storeData?.shopName}`}
                                                            className="text-lg font-semibold hover:opacity-80"
                                                        >
                                                            {storeData?.name}
                                                        </Link>
                                                    </div>
                                                    <div className="flex items-center justify-center">
                                                        <Image
                                                            src={storeData?.imageURL}
                                                            width={150}
                                                            height={150}
                                                            fallback={DefaultImage}
                                                            alt="store image"
                                                            className="rounded-md shadow-sm"
                                                        />
                                                    </div>
                                                    <div className="flex gap-2">
                                                        <img
                                                            src={IconSvg.marker}
                                                            alt="areas"
                                                            className="w-3 h-3"
                                                        />
                                                        <span>{store.address}</span>
                                                    </div>
                                                    <hr />
                                                    {storeData && storeData?.discounts ? (
                                                        <List
                                                            bordered
                                                            size="small"
                                                            dataSource={storeData?.discounts}
                                                            renderItem={(item) => (
                                                                <List.Item>
                                                                    <List.Item.Meta
                                                                        title={
                                                                            <Link
                                                                                to={`/store/${storeData.shopName}`}
                                                                            >
                                                                                {item.name}
                                                                            </Link>
                                                                        }
                                                                    />
                                                                    <span className="font-semibold text-green-500">
                                                                        {item.amount}
                                                                    </span>
                                                                </List.Item>
                                                            )}
                                                        />
                                                    ) : (
                                                        <p> chưa có ưu đãi.</p>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    </Popup>
                                </Marker>
                            ))}
                            <Circle
                                center={[coords.latitude, coords.longitude]}
                                pathOptions={{ fillColor: 'blue' }}
                                radius={1000}
                            />
                        </MapContainer>
                    </div>
                )
            ) : (
                <div className="w-full h-full min-h-screen flex items-center justify-center flex-col gap-2">
                    <Spin />
                    <p>
                        Đang lấy vị trí của bạn... Nếu bạn không thấy thông báo xin hãy bật vị trí
                        lên!
                    </p>
                </div>
            )}
        </div>
    );
}
const DefaultImage =
    'data:image/png;base64,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';
export default Map;
